import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const useMobileDiscoveryNavDocking = () => {
    const [isMobileNavDocked, setIsMobileNavDocked] = useState(false);
    const mobileMapRowRef = useRef(null);
    // Matches media-breakpoint-down(sm), the breakpoint the mobile discovery layout uses.
    const isMobileViewport = useMediaQuery({ maxWidth: 575.98 });

    useEffect(() => {
        if (!isMobileViewport) {
            setIsMobileNavDocked(false);
            return undefined;
        }

        const updateDockedState = () => {
            const mapRow = mobileMapRowRef.current;
            // The tabs overlap the map by 2.9rem, so they dock before the map
            // bottom itself reaches the 11.2rem mobile header edge.
            setIsMobileNavDocked(Boolean(mapRow && mapRow.getBoundingClientRect().bottom <= 141));
        };

        updateDockedState();
        window.addEventListener('scroll', updateDockedState, { passive: true });
        window.addEventListener('resize', updateDockedState);

        return () => {
            window.removeEventListener('scroll', updateDockedState);
            window.removeEventListener('resize', updateDockedState);
        };
    }, [isMobileViewport]);

    return { isMobileNavDocked, isMobileViewport, mobileMapRowRef };
};

export default useMobileDiscoveryNavDocking;
